module.exports = __webpack_public_path__ + "static/media/icon_valor.fc93e138.svg";